import { GET_AREAS, SET_FETECHING, SET_AREA_DATA, CRUD_AREAS, CLEAN_AREAS_ERROR, CHANGE_SETTING_LOCAL, CHANGE_SETTING, CLEAN_AREAS_STATE } from "./types";

const AreasManagementReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_AREAS:
            return {
                ...state,
                areasToConfig: payload.areasToConfig,
                isFetching: false,
                responseAreaService: payload.responseAreaService
            }
        case CRUD_AREAS:
            return {
                ...state,
                isFetching: false,
                responseAreaService: payload.responseAreaService
            }
        case CLEAN_AREAS_STATE:
            return {
                ...state,
                areaData: {
                    areaCode: '',
                    areaDescription: '',
                    areaEnabled: 1,
                    buildingId: null
                },
                responseAreaService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case SET_AREA_DATA:
            return {
                ...state,
                isFetching: false,
                areaData: payload,
            }
        case CLEAN_AREAS_ERROR:
            return {
                ...state,
                responseAreaService: {
                    show: false,
                    type: '',
                    text: '',
                }
            }
        case CHANGE_SETTING:
            return {
                ...state,
                isFetching: false,
                error: payload.error
            }
        case SET_FETECHING:
            return {
                ...state,
                isFetching: payload,
            }
        case CHANGE_SETTING_LOCAL:
            return {
                ...state,
                openningsToConfig: payload,
            }
        default:
            return state;
    }
}

export default AreasManagementReducer;